import React, { memo, useRef } from 'react';
import { connect } from 'react-redux';
import action from '@flux/action';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import Client from '../projectSetting/client';

const ClientDetailForm = (props) => {
  const history = useHistory();
  const clientFormRef = useRef();
  const {
    steps,
    tranStep,
    saveData,
    clientData,
    groupData,
    saveCreateProjectData,
    changeClientsDetail,
  } = props;

  const handlePreviousOrNext = async (action = 'next') => {
    const isNext = action === 'next';
    const step = isNext ? steps[1] : steps[0];

    // 不管是previous还是next都进行校验，否则执行到再下面的代码会导致出现脏数据
    const rres = await clientFormRef.current.getClientForm().validateFields();
    console.log('clientFormRef.current.getClientForm(): ', rres);

    const value = clientFormRef.current.getClientForm().getFieldsValue();
    const res = {
      ...saveData,
      ...value,
    };
    changeClientsDetail(value);
    saveCreateProjectData({
      ...saveData,
      ...res,
      currentStep: tranStep(step),
    });
    history.push(`/projects/create/${step}`);
  };

  const renderAction = () => (
    <div className="form-actions-wrapper setting-btns">
      <Button
        className="previous-btn"
        onClick={() => handlePreviousOrNext('previous')}
      >
        previous
      </Button>

      <Button className="ok-btn" onClick={() => handlePreviousOrNext('next')}>
        next
      </Button>
    </div>
  );

  return (
    <Client
      cRef={clientFormRef}
      renderAction={renderAction}
      clientFormData={clientData}
      createStep
      groupData={groupData}
    />
  );
};

const mapStateToProps = ({ projects }) => ({
  clientData: projects.clientData || {},
  saveData: projects.saveData,
  groupData: projects.groupData,
});

const mapDispatchToProps = (dispatch) => ({
  changeClientsDetail(data) {
    dispatch(action.changeClientsDetail(data));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ClientDetailForm));
